var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badge)?_c('DsfrBadge',{attrs:{"mode":_vm.badge.mode,"show-icon":_vm.badge.mode !== 'NEUTRAL'}},[_c('p',{staticClass:"ma-0 pa-0 text-uppercase"},[_vm._v(_vm._s(_vm.badge.body))])]):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }